import { defineComponent as e } from "vue";
import "./DoubleBounce.css";
const t = e({
  name: "DoubleBounce",
  props: {
    size: { type: Number, default: 0 },
    color: { type: String, default: "" }
  },
  computed: {
    spinnerColor() {
      return this.color || "#ccc";
    },
    spinnerSize() {
      return (this.size || 28) + "px";
    }
  }
});
export {
  t as default
};
